/**
 * Text Formatting Utilities
 */

/**
 * Ensures text ends with a period
 * @param text - The text to format
 * @returns Text with a period at the end
 */
export function ensureEndPeriod(text: string): string {
  if (!text || typeof text !== 'string') return text;

  const trimmed = text.trim();

  // Check if text already ends with punctuation
  const endsWithPunctuation = /[.!?。！？]$/.test(trimmed);

  if (endsWithPunctuation) {
    return trimmed;
  }

  return `${trimmed}.`;
}

/**
 * Formats alternative text to ensure it ends with a period
 * @param alternativeText - The alternative text to format
 * @returns Formatted alternative text with period
 */
export function formatAlternativeText(alternativeText: string): string {
  return ensureEndPeriod(alternativeText);
}
